import React from 'react';
import { ArrowLeft, Plus } from 'phosphor-react';

interface LibraryHeaderProps {
  productCount: number;
  onBack: () => void;
  onAdd: () => void;
}

export default function LibraryHeader({ productCount, onBack, onAdd }: LibraryHeaderProps) {
  return (
    <header className="bg-white dark:bg-gray-900 shadow-soft dark:border-b dark:border-gray-700 px-5 pt-12 pb-5">
      <div className="max-w-lg mx-auto">
        <button
          onClick={onBack}
          className="mb-3 p-2 -ml-2 text-nude-400 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-xl transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
              Minha Biblioteca
            </h1>
            <p className="text-sm text-nude-500 dark:text-gray-400 mt-0.5">
              {productCount} produto{productCount !== 1 ? 's' : ''} cadastrado{productCount !== 1 ? 's' : ''}
            </p>
          </div>
          <button
            onClick={onAdd}
            className="flex items-center gap-1.5 px-3.5 py-2.5 bg-blush-500 hover:bg-blush-600 text-white text-xs font-semibold rounded-xl transition-colors shadow-sm"
          >
            <Plus className="w-3.5 h-3.5" />
            Adicionar
          </button>
        </div>
      </div>
    </header>
  );
}
